import React from "react";
import { Button, Icon, message, Modal, Progress } from "antd";
import loadjs from "loadjs";
// import Row from '../../_antd1.11.2/row'
// import Col from '../../_antd1.11.2/col'
// import Button from '../../_antd1.11.2/button'
// import Icon from '../../_antd1.11.2/icon'
// import message from '../../_antd1.11.2/message'
// import Modal from '../../_antd1.11.2/modal';
// import Progress from '../../_antd1.11.2/progress';
import isEqual from "lodash/isEqual";
import classNames from "classnames";
import WeaLocaleProvider from "../wea-locale-provider";
import { ls } from "../wea-tools/storage";
import { callApi } from "../wea-tools/callApi";
import { ua } from "../wea-tools/userAgent";

import WeaInput from "../wea-input";
import WeaTextarea from "../wea-textarea";
import WeaDragula from "../wea-dragula";
import WindowFunc from "../wea-tools/window";
import WeaPopoverHrm from "../wea-popover-hrm";
import SecLevelDialog from "./secLevelDialog";
import SensitiveDialog from "./sensitiveDialog";
import middleware from "../../middleware";

const getLabel = WeaLocaleProvider.getLabel;
const confirm = Modal.confirm;
// const casProtect = ls.getJSONObj("isOpenClassification") || false;
// import plupload from 'plupload';
// 全局没有问题，打包会 flash 初始化加载会失败 dom 节点都正常
// 下边是官方给出的解决方法，需要全局回调， https://github.com/moxiecode/plupload/issues/1494#issuecomment-317610380
// window.flash_callback_with_unique_name = function (event) {
//  plupload.Uploader.prototype.dispatchEvent(event);
// };
//
// plupload.ua.global_event_dispatcher = 'flash_callback_with_unique_name';

// 判断浏览器是否安装flash插件
const flashChecker = () => {
  let hasFlash = 0; // 是否安装了flash
  let flashVersion = 0; // flash版本

  if (document.all) {
    try {
      const swf = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
      const VSwf = swf.GetVariable("$version");
      flashVersion = parseInt(VSwf.split(" ")[1].split(",")[0]);
    } catch (e) {
      confirm({
        title: getLabel(127354, "警告"),
        content:
          `${e} ` +
          getLabel(
            507489,
            "缺少补丁，无法检测您是否安装 flash 插件，请安装或更新 falsh插件！"
          )
      });
    }
    hasFlash = 1;
  } else {
    if (navigator.plugins && navigator.plugins.length > 0) {
      const swf = navigator.plugins["Shockwave Flash"];
      if (swf) {
        hasFlash = 1;
        const words = swf.description.split(" ");
        for (let i = 0; i < words.length; ++i) {
          if (isNaN(parseInt(words[i]))) continue;
          flashVersion = parseInt(words[i]);
        }
      }
    }
  }
  return { f: hasFlash, v: flashVersion };
};

const fileNameReg = /[\\\\/:*?\"<>|]/g;

class Main extends React.Component {
  static loadjs = loadjs;
  static fileNameReg = fileNameReg;
  static defaultProps = {
    datas: undefined,
    autoUpload: true,
    uploadId: "",
    uploadUrl: "",
    uploadParams: {},
    multiSelection: true,
    forceIE9Flash: true,
    display: true,
    maxUploadSize: 0,
    mixUploadSize: 0,
    maxFilesNumber: Infinity,
    fileDataName: "",
    customOptions: {},
    limitType: "",
    listType: "list",
    viewAttr: 2,
    imgHeight: 50,
    imgWidth: 50,
    category: "",
    showBatchLoad: false,
    value: "",
    btnSize: "default",
    batchLoadUrl: "",
    showClearAll: true,
    showUpload: true,
    errorMsg: "",
    style: {},
    RenderList: undefined,
    RenderListB: undefined,
    useDefaultListB: false,
    clearWhenReset: true,
    showListTop: true,
    showListBottom: true,
    sortable: true,
    editable: false,
    showOrder: false,
    showCancleUpload: false,
    oneline: false,
    className: "",
    replaceWhenOver: true,
    showErrorInfo: true,
    showEditButton: true,
    showUploader: false,
    showUploadTime: false,
    defaultErrorInfo: true,
    showScan: false,
    showHead: false,
    linkHrm: false,
    prohibitType: "",
    dragUpload: false,
    showLoadInFront: false,
    pluginVersion: "2.3.6",
    customButton: null,
    requiredInfo: "",
    showFilesize: true,
    showFullName: false,
    secLevel: "",
    secLevelInfo: "请填写密级",
    showSecLevel: true,
    modifySecUrl: "/api/doc/upload/ModifySecretLevel",
    allowEditSec: true,
    casProtect: false,
    secLevelDisplayFormat: "",
    needCheckSec: true,
    needModifyDocSec: true
  };
  constructor(props) {
    super(props);
    this.instanceIsMounted = false;
    this.state = {
      containerId: `${new Date().getTime()}_${Math.ceil(
        Math.random() * 100000
      )}`,
      listT: [],
      listB: [],
      colspan: 0,
      width: 0,
      hasSetWindow: false,
      scanLoading: false,
      visible: false,
      isEditSec: false,
      currentFile: {},
      sensitiveVisible: false,
      sensitiveList: []
    };
    this.isIE9 = ua.browser === "IE" && parseInt(ua.version) < 10;
    this.playImg = this.playImg.bind(this);
    this.doDeleteB = this.doDeleteB.bind(this);
    this.doDeleteT = this.doDeleteT.bind(this);
  }

  // 获取 window
  getCurrentWindow = () => {
    if (this.state.hasSetWindow) {
      return window["setUploadWindow" + this.state.containerId];
    }
    return WindowFunc.getParent() !== window &&
      $(this.refs.wrap).closest(".ant-modal").length > 0
      ? WindowFunc.getTop()
      : window;
    // return WindowFunc.getParent() !== window
    //   ? WindowFunc.getTop()
    //   : window;
  };

  getCurrentJQuery = () => {
    const currentWindow = this.getCurrentWindow();
    return currentWindow.$ || currentWindow.jQuery;
  };

  componentDidMount() {
    this.instanceIsMounted = true;

    const jq = this.getCurrentJQuery();
    const currentWindow = this.getCurrentWindow();
    const windowEcCom = currentWindow.ecCom;
    let load = windowEcCom ? windowEcCom.WeaUpload.loadjs : loadjs;

    const {
      datas,
      uploadId,
      display,
      needCalculateWidth = true,
      pluginVersion
    } = this.props;
    const { containerId } = this.state;
    const cotWidth = jq(`#${uploadId}_${containerId}`).width() || 0;
    const emWidth = jq(".excelMainTable") ? jq(".excelMainTable").width() : 0;
    const docWidth = jq(currentWindow).width() || 1;
    const denWidth = emWidth || docWidth;
    this.setState({
      listT: datas || [],
      colspan: cotWidth / denWidth,
      width: cotWidth === 0 || !needCalculateWidth ? "100%" : cotWidth
    });
    typeof this.props.getShowListDatas === "function" &&
      this.props.getShowListDatas(datas, this.state.listB);
    // async load file
    const init = () => {
      if (this.isIE9) {
        display === true && this.initUploader();
      } else {
        this.initUploader();
      }
    };
    load.isDefined("pluploadJS")
      ? load.ready("pluploadJS", init)
      : pluginVersion == "debug"
      ? load(
          [
            (window.ecologyContentPath || "") +
              "/cloudstore/resource/pc/plupload-2.3.6/js/moxie.js",
            (window.ecologyContentPath || "") +
              "/cloudstore/resource/pc/plupload-2.3.6/js/plupload.dev.js"
          ],
          "pluploadJS",
          {
            success: init,
            async: false
          }
        )
      : load(
          (window.ecologyContentPath || "") +
            "/cloudstore/resource/pc/plupload-" +
            pluginVersion +
            "/js/plupload.full.min.js",
          "pluploadJS",
          init
        );
    !load.isDefined("imcarouselJS") &&
      load(
        [
          (window.ecologyContentPath || "") + "/social/js/drageasy/drageasy.js",
          (window.ecologyContentPath || "") +
            "/social/js/bootstrap/js/bootstrap.js",
          (window.ecologyContentPath || "") + "/social/im/js/IMUtil_wev8.js",
          (window.ecologyContentPath || "") +
            "/social/js/imcarousel/imcarousel.js"
        ],
        "imcarouselJS"
      );
    // : load('/cloudstore/resource/pc/plupload-2.3.6/plupload.full.min.js', 'pluploadJS', init);
    // async load file
    // if (window !== WindowFunc.getTop()) {
    let topWindow = WindowFunc.getTop();
    let topload = topWindow.ecCom ? topWindow.ecCom.WeaUpload.loadjs : loadjs;
    // }
    !topload.isDefined("imcarouselJS") &&
      topload(
        [
          (window.ecologyContentPath || "") + "/social/js/drageasy/drageasy.js",
          (window.ecologyContentPath || "") +
            "/social/js/bootstrap/js/bootstrap.js",
          (window.ecologyContentPath || "") + "/social/im/js/IMUtil_wev8.js",
          (window.ecologyContentPath || "") +
            "/social/js/imcarousel/imcarousel.js"
        ],
        "imcarouselJS"
      );
  }
  componentWillReceiveProps(nextProps) {
    const {
      datas,
      uploadUrl,
      limitType,
      uploadParams,
      fileDataName,
      customOptions,
      maxUploadSize,
      multiSelection,
      display,
      dragUpload,
      uploadId,
      needCalculateWidth = true,
      secLevel,
      modifySecUrl,
      needCheckSec,
      needModifyDocSec
    } = this.props;
    const { listT, containerId } = this.state;
    const nextPropDatas = nextProps.datas;
    let nextPropUploadUrl = nextProps.uploadUrl || "";
    const nextPropLimitType = nextProps.limitType || "";
    const nextPropUploadParams = nextProps.uploadParams || {};
    const nextPropMaxUploadSize = nextProps.maxUploadSize || 0;
    const nextPropSecLevel = nextProps.secLevel || "";
    const nextPropMultiSelection =
      nextProps.multiSelection !== undefined ? nextProps.multiSelection : true;
    const nextPropDisplay =
      nextProps.display === false ? nextProps.display : true;
    const nextFileDataName = nextProps.fileDataName || "";
    const nextCustomOptions = nextProps.customOptions || {};
    const nextDragUpload = nextProps.dragUpload || false;
    let newLimitType = "";
    const jq = this.getCurrentJQuery();
    const currentWindow = this.getCurrentWindow();
    if (nextProps.casProtect && nextProps.casProtect !== "false") {
      if (nextPropSecLevel === "4") {
        if (this.isIE9) {
          jq(`#container_${uploadId}_${containerId} object`).css(
            "display",
            "block"
          );
        } else {
          jq(`#container_${uploadId}_${containerId} input`).attr(
            "disabled",
            false
          );
        }
      } else {
        if (this.isIE9) {
          jq(`#container_${uploadId}_${containerId} object`).css(
            "display",
            "none"
          );
        } else {
          jq(`#container_${uploadId}_${containerId} input[type="file"]`).attr(
            "disabled",
            true
          );
        }
        if (this.filePicker) {
          this.setState({ visible: false });
          this.filePicker = false;
        }
      }
    }
    if (
      limitType !== nextPropLimitType ||
      maxUploadSize !== nextPropMaxUploadSize
    ) {
      let uploadSuffixLimit = ls.getStr("uploadSuffixLimit") || "*.*";
      if (uploadSuffixLimit == "undefined") {
        uploadSuffixLimit = "*.*";
      }
      if (uploadSuffixLimit == "*.*") {
        // 配置文件无限制
        newLimitType = nextPropLimitType;
      } else {
        // 配置文件有限制
        if (!nextPropLimitType) {
          newLimitType = uploadSuffixLimit
            .replace(/;/g, ",")
            .replace(/\*./g, "");
        } else {
          // 取交集
          const obj1 = uploadSuffixLimit
            .replace(/;/g, ",")
            .replace(/\*./g, "")
            .split(",");
          const obj2 = nextPropLimitType.split(",");
          const intersection = obj2.filter(v => {
            return obj1.some(s => {
              return s.toLowerCase() === v.toLowerCase();
            });
          });
          newLimitType = intersection.join(",");
          if (!newLimitType) {
            newLimitType = "";
          }
        }
      }
    }
    if (this.isIE9 && display === false && nextPropDisplay === true) {
      !this.uploader && this.initUploader();
    }
    if (display === false && nextPropDisplay === true) {
      const cotWidth = jq(`#${uploadId}_${containerId}`).width() || 0;
      const emWidth = jq(".excelMainTable") ? jq(".excelMainTable").width() : 0;
      const docWidth = jq(currentWindow).width() || 1;
      const denWidth = emWidth || docWidth;
      this.setState({
        colspan: cotWidth / denWidth,
        width: cotWidth === 0 || !needCalculateWidth ? "100%" : cotWidth
      });
    }
    if (nextPropDatas && !isEqual(datas, nextPropDatas)) {
      this.setState({ listT: nextPropDatas });
      typeof this.props.getShowListDatas === "function" &&
        this.props.getShowListDatas(nextPropDatas, this.state.listB);
    }
    let resetOptions = {};
    if (uploadUrl !== nextPropUploadUrl) {
      var reg = new RegExp("^" + window.ecologyContentPath + "");
      nextPropUploadUrl = reg.test(nextPropUploadUrl)
        ? nextPropUploadUrl
        : (window.ecologyContentPath || "") + nextPropUploadUrl;

      resetOptions.url = nextPropUploadUrl;
    }
    if (limitType !== nextPropLimitType) {
      resetOptions.filters = {
        mime_types: newLimitType
          ? [
              {
                title: "limitType",
                extensions:
                  newLimitType.indexOf("jpg") >= 0
                    ? `${newLimitType}`
                    : newLimitType
              }
            ]
          : [],
        prevent_duplicates: false // 不允许选取重复文件
      };
    }
    if (maxUploadSize !== nextPropMaxUploadSize) {
      const filters = { max_file_size: `${nextPropMaxUploadSize}mb` };
      resetOptions.filters = {
        mime_types: newLimitType
          ? [
              {
                title: "limitType",
                extensions:
                  newLimitType.indexOf("jpg") >= 0
                    ? `${newLimitType}`
                    : newLimitType
              }
            ]
          : [],
        prevent_duplicates: false // 不允许选取重复文件
      };
      resetOptions.filters = resetOptions.filters
        ? { ...resetOptions.filters, ...filters }
        : filters;
    }
    if (multiSelection !== nextPropMultiSelection) {
      resetOptions.multi_selection = nextPropMultiSelection;
    }
    if (!isEqual(uploadParams, nextPropUploadParams)) {
      resetOptions.multipart_params = {
        ...nextPropUploadParams,
        nextPropSecLevel,
        ts: new Date().getTime()
      };
    }
    if (
      nextProps.casProtect &&
      nextProps.casProtect !== "false" &&
      nextPropSecLevel === "4" &&
      secLevel !== nextPropSecLevel
    ) {
      resetOptions.multipart_params = {
        ...resetOptions.multipart_params,
        secretLevel: nextPropSecLevel,
        secretLevelValidity: ""
      };
    }
    if (fileDataName !== nextFileDataName) {
      resetOptions.file_data_name = nextFileDataName;
    }
    if (!isEqual(customOptions, nextCustomOptions)) {
      resetOptions = { ...resetOptions, ...nextCustomOptions };
    }
    if (!isEqual(dragUpload, nextDragUpload)) {
      resetOptions.dragUpload = nextDragUpload;
    }
    Object.keys(resetOptions).length > 0 &&
      this.resetUploaderOption(resetOptions);
    if (secLevel && secLevel < nextPropSecLevel && needCheckSec) {
      const newDatas = nextPropDatas || listT || [];
      // 高密级调整为低密级
      const fileids = newDatas.map(item => item.imagefileid || item.fileid);
      let otherParams = {};
      if (needModifyDocSec) {
        otherParams = {
          ismodifydoc: 1,
          docid: newDatas.map(item => item.fileid)
        };
      }
      if (fileids.length > 0) {
        const params = {
          imagefileid: fileids.join(","),
          secretLevel: nextProps.secLevel,
          secretLevelValidity: nextProps.secretLevelValidity || "",
          ...otherParams
        };
        callApi(modifySecUrl, "POST", params).then(res => {
          if (res.api_status) {
            const newReDatas = newDatas.map(item => {
              item.secretLevel = nextProps.secLevel;
              item.secretLevelValidity = nextProps.secretLevelValidity;
              item.secretLevelValidityValue = res.secretLevelValidityValue;
              return item;
            });
            this.onChange(newReDatas);
            this.setState({
              listT: newReDatas
            });
          }
        });
      }
    }
  }
  componentDidUpdate() {
    this.uploader && this.uploader.refresh();
    const { uploadId } = this.props;
    const { containerId } = this.state;
    const jq = this.getCurrentJQuery();
    if (this.props.casProtect && this.props.casProtect !== "false") {
      if (this.props.secLevel === "4") {
        if (this.isIE9) {
          jq(`#container_${uploadId}_${containerId} object`).css(
            "display",
            "block"
          );
        } else {
          jq(`#container_${uploadId}_${containerId} input`).attr(
            "disabled",
            false
          );
        }
      } else {
        if (this.isIE9) {
          jq(`#container_${uploadId}_${containerId} object`).css(
            "display",
            "none"
          );
        } else {
          jq(`#container_${uploadId}_${containerId} input[type="file"]`).attr(
            "disabled",
            true
          );
        }
      }
      if (this.filePicker) {
        this.setState({ visible: false });
        this.filePicker = false;
      }
    }
    // const list = this.refs.listT;
    // let nodes = [];
    // if (list) {
    //   nodes = list.querySelectorAll(".wea-upload-list-content");
    // }
    // const { listT } = this.state;
    // let ischange = false;
    // if (nodes && nodes.length > 0) {
    //   for (let i = 0; i < nodes.length; i++) {
    //     let overflow = false;
    //     if (listT[i] && "overflow" in listT[i]) {
    //       overflow = listT[i].overflow;
    //     }
    //     if (
    //       nodes[i].scrollWidth > nodes[i].clientWidth &&
    //       !overflow &&
    //       listT[i]
    //     ) {
    //       listT[i].overflow = true;
    //       ischange = true;
    //     } else if (nodes[i].scrollWidth <= nodes[i].clientWidth && overflow) {
    //       listT[i].overflow = false;
    //       ischange = true;
    //     }
    //   }
    //   // nodes.forEach((item, index) => {
    //   //   let overflow = false;
    //   //   if (listT[index] && "overflow" in listT[index]) {
    //   //     overflow = listT[index].overflow;
    //   //   }
    //   //   if (item.scrollWidth > item.clientWidth && !overflow && listT[index]) {
    //   //     listT[index].overflow = true;
    //   //     ischange = true;
    //   //   } else if (item.scrollWidth <= item.clientWidth && overflow) {
    //   //     listT[index].overflow = false;
    //   //     ischange = true;
    //   //   }
    //   // });
    // }
    // if (ischange) {
    //   this.setState({ listT });
    // }
  }
  componentWillUnmount() {
    this.instanceIsMounted = false;
    this.uploader && this.uploader.unbindAll();
    this.uploader && this.uploader.destroy();
    const { autoUpload = true } = this.props;
    if (!autoUpload) {
      window.startUploadAll = null;
    }
  }
  onChange(listT, listB = []) {
    const list = [];
    listT.forEach(t => {
      const {
        fileExtendName,
        fileid,
        filelink,
        filename,
        filesize,
        imgSrc,
        loadlink,
        showLoad,
        showDelete,
        isImg,
        imagefileid,
        fileID,
        appID,
        username,
        uploaddate,
        userid,
        fileidCode,
        size,
        secretLevel,
        secretLevelValidity,
        secretLevelValidityValue
      } = t;
      list.push({
        fileExtendName,
        fileid,
        filelink,
        filename,
        filesize,
        imgSrc,
        loadlink,
        showLoad,
        showDelete,
        isImg,
        imagefileid,
        fileID,
        appID,
        username,
        uploaddate,
        userid,
        fileidCode,
        size,
        secretLevel,
        secretLevelValidity,
        secretLevelValidityValue
      });
    });
    const ids = listT.map(t => t.fileid);
    this.setState({ listT }); // 刷新序号
    if (typeof this.props.onChange === "function") {
      this.props.onChange(ids, list, listT, listB);
    }
  }
  getWidth() {
    const jq = this.getCurrentJQuery();
    const currentWindow = this.getCurrentWindow();

    const { uploadId, needCalculateWidth = true } = this.props;
    const { containerId, colspan } = this.state;
    const cotWidth = jq(`#${uploadId}_${containerId}`).width() || 0;
    const emWidth = jq(".excelMainTable") ? jq(".excelMainTable").width() : 0;
    const docWidth = jq(currentWindow).width() || 1;
    const denWidth = emWidth || docWidth;
    let width = denWidth * colspan;
    width =
      width === 0 || cotWidth === 0 || !needCalculateWidth
        ? "100%"
        : width > cotWidth
        ? cotWidth
        : width > 800
        ? 800
        : width < 170
        ? 170
        : width;
    this.setState({ width });
  }
  doUpload() {
    const { listB } = this.state;
    typeof this.props.onUploading === "function" &&
      this.props.onUploading("uploading", listB);
    this.uploader && this.uploader.start();
  }
  resetListB = () => {
    const { viewAttr } = this.props;
    const { listT, listB } = this.state;
    listB.forEach(file => {
      this.uploader && this.uploader.removeFile(file.id);
    });
    this.setState({ listB: [] });
    typeof this.props.getShowListDatas === "function" &&
      this.props.getShowListDatas(listT, []);
    const required = viewAttr === 3 && listT.length === 0;
    typeof this.props.onUploading === "function" &&
      this.props.onUploading(required ? "true" : "false");
  };
  clearAllFiles = () => {
    // 仅删除下部的，批量上传有效
    confirm({
      title: getLabel(385911, "确定要删除所有吗？"),
      content: "",
      onOk: () => {
        const { viewAttr } = this.props;
        const { listT, listB } = this.state;
        listB.forEach(file => {
          this.uploader && this.uploader.removeFile(file.id);
        });
        this.setState({ listB: [] });
        typeof this.props.getShowListDatas === "function" &&
          this.props.getShowListDatas(listT, []);
        const required = viewAttr === 3 && listT.length === 0;
        typeof this.props.onUploading === "function" &&
          this.props.onUploading(required ? "true" : "false");
      }
    });
  };
  cancleUpload = () => {
    confirm({
      title: getLabel(508772, "确定要取消上传吗？"),
      content: "",
      onOk: () => {
        const { viewAttr } = this.props;
        const { listT, listB } = this.state;
        listB.forEach(file => {
          this.uploader && this.uploader.removeFile(file.id);
        });
        this.setState({ listB: [] });
        typeof this.props.getShowListDatas === "function" &&
          this.props.getShowListDatas(listT, []);
        const required = viewAttr === 3 && listT.length === 0;
        typeof this.props.onUploading === "function" &&
          this.props.onUploading(required ? "true" : "false");
      }
    });
  };
  doDeleteT(fileid) {
    // event.stopPropagation();
    // 删除上部的，自动上传需调用onchange
    const { autoUpload, viewAttr } = this.props;
    const { listT, listB } = this.state;
    let newListT = [].concat(listT);
    let title = "";
    newListT.forEach(file => {
      if (fileid === file.fileid) {
        title = file.filename;
      }
    });
    newListT = newListT.filter(file => fileid !== file.fileid);
    const warnText = getLabel(385912, "确定要删除{title}吗？");
    confirm({
      title:
        warnText.slice(0, warnText.indexOf("{")) +
        title +
        warnText.slice(warnText.indexOf("}") + 1),
      content: "",
      onOk: () => {
        this.setState({ listT: newListT });
        typeof this.props.getShowListDatas === "function" &&
          this.props.getShowListDatas(newListT, listB);
        typeof this.props.onDelete === "function" &&
          this.props.onDelete(newListT, listB);
        if (autoUpload) {
          this.onChange(newListT, listB);
        } else {
          this.onChange(newListT, []);
          const required =
            viewAttr === 3 && newListT.length === 0 && listB.length === 0;
          typeof this.props.onUploading === "function" &&
            this.props.onUploading(required ? "true" : "false");
        }
      }
    });
  }
  doDeleteB(id) {
    // 仅删除下部的，批量上传有效
    const { viewAttr } = this.props;
    const { listT, listB } = this.state;
    let newListB = [].concat(listB);
    let title = "";
    newListB.forEach(file => {
      if (id === file.id) {
        title = file.name;
      }
    });
    newListB = newListB.filter(file => id !== file.id);
    let warnText = getLabel(510362, "确定要取消上传{title}吗？");
    warnText = warnText.replace("{title}", title);
    confirm({
      title: warnText,
      content: "",
      onOk: () => {
        this.uploader && this.uploader.removeFile(id);
        this.setState({ listB: newListB });
        typeof this.props.getShowListDatas === "function" &&
          this.props.getShowListDatas(listT, newListB);
        const required =
          viewAttr === 3 && listT.length === 0 && newListB.length === 0;
        typeof this.props.onUploading === "function" &&
          this.props.onUploading(required ? "true" : "false");
      }
    });
  }
  resetUploaderOption(options, clear = true) {
    this.uploader && this.uploader.setOption(options);
    this.props.clearWhenReset && clear && this.resetListB();
  }
  initUploader() {
    const {
      uploadId,
      autoUpload,
      limitType,
      maxUploadSize,
      multiSelection,
      forceIE9Flash,
      uploadParams,
      fileDataName,
      customOptions,
      showErrorInfo,
      dragUpload,
      pluginVersion,
      secLevel,
      casProtect
    } = this.props;
    let uploadUrl = this.props.uploadUrl;
    const { containerId } = this.state;
    let newLimitType = "";
    let uploadSuffixLimit = ls.getStr("uploadSuffixLimit") || "*.*";
    if (uploadSuffixLimit == "undefined") {
      uploadSuffixLimit = "*.*";
    }
    if (uploadSuffixLimit == "*.*") {
      // 配置文件无限制
      newLimitType = limitType;
    } else {
      // 配置文件有限制
      if (!limitType) {
        newLimitType = uploadSuffixLimit.replace(/;/g, ",").replace(/\*./g, "");
      } else {
        // 取交集
        const obj1 = uploadSuffixLimit
          .replace(/;/g, ",")
          .replace(/\*./g, "")
          .split(",");
        const obj2 = limitType.split(",");
        const intersection = obj2.filter(v => {
          return obj1.some(s => {
            return s.toLowerCase() === v.toLowerCase();
          });
        });
        newLimitType = intersection.join(",");
        if (!newLimitType) {
          newLimitType = "";
        }
      }
    }
    const filters = {
      mime_types: newLimitType
        ? [
            {
              title: "limitType",
              extensions:
                newLimitType.indexOf("jpg") >= 0
                  ? `${newLimitType}`
                  : newLimitType
            }
          ]
        : [],
      prevent_duplicates: false // 不允许选取重复文件
    };
    if (maxUploadSize) filters.max_file_size = `${maxUploadSize}mb`; // 最大上传大小

    let currentWindow = this.getCurrentWindow();
    const jq = this.getCurrentJQuery();

    // special for meeting
    if (currentWindow.plupload === undefined) {
      currentWindow = WindowFunc.getTop();
      window["setUploadWindow" + containerId] = currentWindow;
      this.setState({ hasSetWindow: true });
    }
    let newCustomOptions = {};
    if (dragUpload) {
      newCustomOptions = {
        drop_element: `browsebtn_${uploadId}_${containerId}`,
        ...customOptions
      };
    }

    if (!/^http/.test(uploadUrl)) {
      var reg = new RegExp("^" + window.ecologyContentPath + "");
      uploadUrl = reg.test(uploadUrl)
        ? uploadUrl
        : (window.ecologyContentPath || "") + uploadUrl;
    }

    this.uploader = new currentWindow.plupload.Uploader({
      container: `container_${uploadId}_${containerId}`,
      browse_button: `browsebtn_${uploadId}_${containerId}`,
      runtimes: forceIE9Flash && this.isIE9 ? "flash" : "html5,html4,flash",
      // runtimes: 'flash',
      ...(fileDataName ? { file_data_name: fileDataName } : {}),
      multipart: true, // multipart/form-data的形式来上传文件
      multipart_params: {
        ...uploadParams,
        secretLevel: secLevel,
        ts: new Date().getTime()
      },
      chunk_size: "0", // 分片上传大小
      url: uploadUrl,
      flash_swf_url:
        (window.ecologyContentPath || "") +
        "/cloudstore/resource/pc/plupload-" +
        pluginVersion +
        "/js/Moxie.swf",
      filters,
      multi_selection: multiSelection, // 默认开启多选文件
      // drop_element: dragUpload ? `browsebtn_${uploadId}_${containerId}` : '',
      ...newCustomOptions,
      ...customOptions
    });
    // 初始化
    this.uploader.init();
    // 绑定主要事件,state同步

    // const uploadEvents = [
    //  'PostInit', 'Browse', 'Refresh', 'StateChanged', 'QueueChanged', 'OptionChanged',
    //  'BeforeUpload', 'UploadProgress', 'FileFiltered', 'FilesAdded',
    //  'FilesRemoved', 'FileUploaded', 'ChunkUploaded',
    //  'UploadComplete', 'Destroy', 'Error'
    // ];

    // 新增上传
    this.uploader.bind("FilesAdded", (up, files) => {
      const {
        maxFilesNumber = Infinity,
        totolMaxUploadSize = Infinity,
        limitType,
        mixUploadSize,
        replaceWhenOver,
        prohibitType
      } = this.props;
      const { listT, listB } = this.state;
      let newListB = listB.concat(files);
      if (totolMaxUploadSize && totolMaxUploadSize !== Infinity) {
        let total = 0;
        listT.forEach(t => {
          total +=
            t.filesizeByte ||
            t.size ||
            (t.filesize &&
              (t.filesize.indexOf("M") !== -1
                ? t.filesize.slice(0, -1) * 1024 * 1024
                : t.filesize.indexOf("K") !== -1
                ? t.filesize.slice(0, -1) * 1024
                : t.filesize.slice(0, -1))) ||
            0;
        });
        newListB.forEach(b => {
          total += b.size;
        });
        if (total > totolMaxUploadSize * 1024 * 1024) {
          let errorMsg = getLabel(385913, "超出总大小{size}MB限制!");
          errorMsg = errorMsg.replace("{size}", totolMaxUploadSize);
          message.error(errorMsg, 1.5);
          return;
        }
      }
      newListB = newListB.filter(file => {
        if (file.size && file.size < mixUploadSize * 1024 * 1024) {
          // 过滤低于最小上传大小限制的文件
          let errorMsg = getLabel(505898, "低于最小{size}MB限制!");
          errorMsg = errorMsg.replace("{size}", mixUploadSize);
          message.error(errorMsg, 1.5);
          return false;
        } else {
          return true;
        }
      });
      newListB = newListB.map(file => {
        const newFile = { ...file, WEA_NATIVE_FILE: file };
        if (!newFile.progress) {
          newFile.progress = 1;
        }
        if (autoUpload) newFile.showProgress = true;
        return newFile;
      });
      const overflowNumber = newListB.length - maxFilesNumber;
      if (!replaceWhenOver && newListB.length + listT.length > maxFilesNumber) {
        newListB = newListB.slice(0, maxFilesNumber - listT.length);
        this.setState({ listB: newListB });
        let errorMsg = getLabel(509549, "文件数量不能超过 {maxFilesNumber} 个");
        errorMsg = errorMsg.replace("{maxFilesNumber}", maxFilesNumber);
        message.error(errorMsg, 1.5);
      } else {
        if (overflowNumber > 0) {
          // const removeList = [...newListB];
          // removeList
          //   .slice(1, overflowNumber)
          //   .forEach(file => up.removeFile(file));
          up.splice(0, overflowNumber);
          newListB = newListB.slice(-maxFilesNumber);
        }
        this.setState({ listB: newListB });
      }
      const noLimitType = prohibitType.split(",").filter(item => item !== "");
      newListB = newListB.filter(file => {
        const index = file.name.lastIndexOf(".");
        const suffix = index === -1 ? "" : file.name.substr(index + 1);
        if (
          noLimitType.some(item => item.toLowerCase() === suffix.toLowerCase())
        ) {
          // 过滤禁止上传的文件类型
          let errorMsg = getLabel(385919, "上传文件类型错误，请重新上传!");
          message.error(errorMsg, 1.5);
          this.uploader.removeFile(file.id);
          return false;
        } else {
          return true;
        }
      });
      this.setState({ listB: newListB });
      typeof this.props.getShowListDatas === "function" &&
        this.props.getShowListDatas(this.state.listT, newListB);
      if (autoUpload && newListB.length > 0) {
        this.doUpload();
      } else {
        typeof this.props.onUploading === "function" &&
          this.props.onUploading("false");
      }
    });
    // 删除文件
    this.uploader.bind("FilesRemoved", (up, rmFiles) => {
      const { listB } = this.state;
      let newListB = [].concat(listB);
      rmFiles.forEach(rf => {
        newListB = newListB.filter(file => rf.id !== file.id);
      });
      this.setState({ listB: newListB });
      typeof this.props.getShowListDatas === "function" &&
        this.props.getShowListDatas(this.state.listT, newListB);
    });

    // 抛错
    this.uploader.bind("Error", (up, err) => {
      if (err.code === -500) {
        console && console.error(getLabel(385914, "上传组件初始化出错!"));
      } else if (err.code === -702) {
        message.error(
          getLabel(385917, "文件大小超出组件所能处理的最大值，请重新上传!"),
          3
        );
      } else if (err.code === -600) {
        if (showErrorInfo) {
          message.error(
            err.file.size === 0
              ? getLabel("529543", "上传文件大小不能为0，请重新上传")
              : getLabel(
                  531974,
                  "上传文件超出限制大小{max}，请重新上传!"
                ).replace("{max}", maxUploadSize + "M"),
            3
          );
        } else {
          confirm({
            className: "wea-upload-confirm-error-info",
            title:
              err.file.size === 0
                ? getLabel("529543", "上传文件大小不能为0，请重新上传")
                : getLabel(
                    531974,
                    "上传文件超出限制大小{max}，请重新上传!"
                  ).replace("{max}", maxUploadSize + "M"),
            content: err.file.name
          });
        }
      } else if (err.code === -601) {
        if (limitType.toLowerCase() === "docx") {
          message.error(getLabel(505349, "仅支持docx文件，请上传docx文件!"), 3);
        } else {
          message.error(getLabel(385919, "上传文件类型错误，请重新上传!"), 3);
        }
      } else if (err.code === -602) {
        message.error(getLabel(385920, "上传文件重复，请重新上传!"), 3);
      } else if (err.code === -200) {
        message.error(getLabel(385921, "上传接口出错，请重新上传!"), 3);
        // console && console.error('上传组件出错，请联系管理员!');
      } else {
        // message.error('上传组件出错，请联系管理员!',3);
        // console && console.error('上传组件出错，请联系管理员!');
      }
      if (err.file) {
        const { listB } = this.state;
        const newListB = [].concat(
          listB.filter(file => file.id !== err.file.id)
        );
        if (err.code === -600) {
          err.file.error =
            err.file.size === 0
              ? getLabel("505710", "文件为空")
              : getLabel(125378, "文件过大");
        } else if (err.code === -601) {
          err.file.error = getLabel(127241, "类型错误");
        } else if (err.code === -200) {
          err.file.error = getLabel(385916, "接口错误");
        } else {
          err.file.error = getLabel(129710, "未知错误");
        }
        if (autoUpload) {
          err.file.progress = 50;
          err.file.progressStatus = "exception";
          err.file.showProgress = true;
        }
        newListB.push(err.file);
        this.setState({ listB: newListB });
        typeof this.props.getShowListDatas === "function" &&
          this.props.getShowListDatas(this.state.listT, newListB);
        setTimeout(() => {
          const stlistB = this.state.listB;
          let stNewListB = [].concat(stlistB);
          stNewListB = stNewListB.filter(file => !file.error);
          this.setState({ listB: stNewListB });
          typeof this.props.getShowListDatas === "function" &&
            this.props.getShowListDatas(this.state.listT, stNewListB);
        }, 2000);
      }
    });
    // 上传进度
    this.uploader.bind("UploadProgress", (up, pgFile) => {
      const { listB } = this.state;
      let newListB = [].concat(listB);
      newListB = newListB.map(file => {
        if (pgFile.id === file.id) {
          const newFile = { ...file };
          if (pgFile.percent !== undefined) {
            if (pgFile.percent <= 99) {
              newFile.progress = pgFile.percent;
            } else {
              newFile.progress = 99;
            }
          } else if (newFile.loaded && newFile.size) {
            const p = parseInt((newFile.loaded * 100) / newFile.size);
            newFile.progress = p;
          } else if (newFile.progress < 90) {
            newFile.progress += 10;
          } else {
            newFile.progress = 99;
          }
          return newFile;
        } else {
          return file;
        }
      });
      this.setState({ listB: newListB });
      typeof this.props.onUploading === "function" &&
        this.props.onUploading("uploading", newListB, this.uploader.total);
      typeof this.props.getShowListDatas === "function" &&
        this.props.getShowListDatas(
          this.state.listT,
          newListB,
          this.uploader.total
        );
    });
    // 分片上传完成
    // this.uploader.bind('ChunkUploaded', (up, ckFile, res) => {
    //  console.log('分片上传完成 ChunkUploaded: ', ckFile, res)
    // });
    // 某个文件上传完
    this.uploader.bind("FileUploaded", (up, upFile, res) => {
      const upError =
        res.status !== 200 ||
        !res.response ||
        (res.response &&
          (JSON.parse(res.response).status === false ||
            JSON.parse(res.response).status === "false" ||
            !JSON.parse(res.response).data));
      if (upError) {
        const result = res.response && JSON.parse(res.response);
        if (result.sensitiveInfo) {
          let sensitiveList = this.state.sensitiveList;
          sensitiveList = sensitiveList.concat(result.sensitiveInfo);
          this.setState({ sensitiveList });
        }
        const { listB } = this.state;
        let newListB = [].concat(listB);
        newListB = newListB.map(file => {
          if (upFile.id === file.id) {
            const newFile = { ...file };
            newFile.error = !newFile.size
              ? getLabel(505710, "文件为空")
              : res.response && JSON.parse(res.response).msg
              ? JSON.parse(res.response).msg
              : getLabel(385915, "上传服务器失败");
            newFile.progressStatus = "exception";
            newFile.progress = 100;
            newFile.showProgress = true;
            if (!newFile.size) {
              message.error(
                `${newFile.name} ${getLabel(
                  505335,
                  "为空文件，无法上传，请您重新选择"
                )}`,
                3
              );
            } else {
              if (!result.sensitiveInfo) {
                message.error(`${newFile.name} ${newFile.error}`, 3);
              }
            }
            return newFile;
          } else {
            return file;
          }
        });
        this.setState({ listB: newListB });
        typeof this.props.getShowListDatas === "function" &&
          this.props.getShowListDatas(this.state.listT, newListB);
        typeof this.props.onUploading === "function" &&
          this.props.onUploading("error");
        typeof this.props.onUploaded === "function" &&
          this.props.onUploaded(this.state.listT, newListB);
      } else {
        const { listB } = this.state;
        let newListB = [].concat(listB);
        newListB = newListB.map(file => {
          if (upFile.id === file.id) {
            const newFile = { ...file, ...JSON.parse(res.response).data };
            newFile.progress = 100;
            return newFile;
          } else {
            return file;
          }
        });
        this.setState({ listB: newListB });
        typeof this.props.getShowListDatas === "function" &&
          this.props.getShowListDatas(this.state.listT, newListB);
        typeof this.props.onUploaded === "function" &&
          this.props.onUploaded(this.state.listT, newListB);
      }
    });
    // 全部文件上传完成
    this.uploader.bind("UploadComplete", () => {
      setTimeout(() => {
        const { maxFilesNumber } = this.props;
        const { listT, listB, sensitiveList } = this.state;
        let find = false;
        listB.forEach(file => {
          if (file.error) find = true;
        });
        if (sensitiveList.length > 0) {
          this.setState({ sensitiveVisible: true });
        }
        if (find) {
          setTimeout(() => {
            const nowListT = this.state.listT;
            const nowListB = this.state.listB;
            let newListB = [].concat(nowListB);
            newListB = newListB.filter(file => !file.error);
            let newListT = nowListT.concat(newListB);
            const overflowNumber = newListT.length - maxFilesNumber;
            overflowNumber > 0 && (newListT = newListT.slice(-maxFilesNumber));
            this.onChange(newListT, newListB);
            this.setState({ listT: newListT, listB: [] });
            typeof this.props.getShowListDatas === "function" &&
              this.props.getShowListDatas(newListT, []);
            typeof this.props.onUploading === "function" &&
              sensitiveList.length == 0 &&
              this.props.onUploading("uploaded");
            typeof this.props.onUploaded === "function" &&
              this.props.onUploaded(newListT, []);
          }, 2000);
        } else {
          let newListT = listT.concat(listB);
          const overflowNumber = newListT.length - maxFilesNumber;
          overflowNumber > 0 && (newListT = newListT.slice(-maxFilesNumber));
          this.onChange(newListT, listB);
          this.setState({ listT: newListT, listB: [] });
          typeof this.props.getShowListDatas === "function" &&
            this.props.getShowListDatas(newListT, []);
          typeof this.props.onUploading === "function" &&
            sensitiveList.length == 0 &&
            this.props.onUploading("uploaded");
          typeof this.props.onUploaded === "function" &&
            this.props.onUploaded(newListT, []);
        }
      }, 200);
    });
    // 全局调用
    if (!autoUpload) {
      let startUploadAllOld;
      if (typeof currentWindow.startUploadAll === "function") {
        startUploadAllOld = currentWindow.startUploadAll;
      }
      currentWindow.startUploadAll = () => {
        const { listB } = this.state;
        if (listB.length > 0) {
          let newListB = [].concat(listB);
          newListB = newListB.map(file => {
            const newFile = { ...file };
            newFile.progress = 1;
            newFile.showProgress = true;
            return newFile;
          });
          this.setState({ listB: newListB });
          typeof this.props.getShowListDatas === "function" &&
            this.props.getShowListDatas(this.state.ListT, newListB);
          this.doUpload();
        }
        typeof startUploadAllOld === "function" && startUploadAllOld();
      };
    }
    // flash 遮罩无法 hover 问题
    this.uploader.bind("Init", () => {
      const { getCurrentInstance, secLevel } = this.props;
      if (typeof getCurrentInstance === "function") {
        getCurrentInstance(this);
      }
      if (ua.browser === "IE" && parseInt(ua.version, 10) < 10) {
        jq(`#container_${uploadId}_${containerId}>div.moxie-shim-flash`).hover(
          () => {
            jq(`button#browsebtn_${uploadId}_${containerId}`).css({
              color: "#57c5f7",
              borderColor: "#57c5f7"
            });
            jq(`i#browsebtn_${uploadId}_${containerId}`).css({
              color: "#289cff"
            });
          },
          () => {
            jq(`button#browsebtn_${uploadId}_${containerId}`).css({
              color: "#000",
              borderColor: "#d9d9d9"
            });
            jq(`i#browsebtn_${uploadId}_${containerId}`).css({
              color: "#a8a8a8"
            });
          }
        );
      }
      if (casProtect && casProtect != "false" && secLevel != "4") {
        // this.uploader.settings.browse_button[0].setAttribute('selectable', false)
        if (this.isIE9) {
          jq(`#container_${uploadId}_${containerId} object`).css(
            "display",
            "none"
          );
        } else {
          jq(`#container_${uploadId}_${containerId} input[type="file"]`).attr(
            "disabled",
            true
          );
        }
      }
    });
  }

  playImg(d, e) {
    const jq = this.getCurrentJQuery();
    const fn = () => {
      // 图片轮播
      const jq = this.getCurrentJQuery();
      const currentWindow = this.getCurrentWindow();
      const imgPool = [];
      let indexNum = 0;
      jq(".formImgPlay").each(function() {
        imgPool.push(jq(this).attr("data-imgsrc") || jq(this).attr("src"));
      });
      for (let i = 0; i < imgPool.length; i++) {
        const imgSrc = !!jq(e.target).attr("data-imgsrc")
          ? jq(e.target).attr("data-imgsrc")
          : jq(e.target).attr("src");
        if (imgSrc === imgPool[i]) {
          var reg = new RegExp("^" + window.ecologyContentPath + "");
          imgPool[i] = reg.test(imgPool[i])
            ? imgPool[i]
            : (window.ecologyContentPath || "") + imgPool[i];
          break;
        } else {
          indexNum++;
        }
      }
      // console.log("imgPool--",imgPool,"indexNum--",indexNum);
      let languageId = 7;
      if (window["e9_locale"]) {
        languageId = window["e9_locale"].userLanguage;
      }
      IMCarousel.showImgScanner4Pool(
        true,
        imgPool,
        indexNum,
        null,
        WindowFunc.getTop(),
        languageId
      );
    };
    if (typeof this.props.onItemClick === "function") {
      this.props.onItemClick(
        jq(e.target).attr("data-imgsrc") || jq(e.target).attr("src")
      );
    } else if (typeof this.props.onCheckPreview === "function") {
      this.props.onCheckPreview(d, fn);
    } else {
      fn();
    }
  }

  download(downloadURL, d, e) {
    e && e.stopPropagation && e.stopPropagation();
    const fn = () => {
      const { uploadId } = this.props;
      const { containerId = "" } = this.state;
      const frame = this.refs[`download_${uploadId}_${containerId}`];
      if (frame) {
        const u = window.navigator.userAgent;
        // if (
        //   u.indexOf("Windows") > -1 &&
        //   (u.indexOf("Chrome") > -1 || u.indexOf("CriOS") > -1) &&
        //   Number(u.replace(/^.*Chrome\/([\d]+).*$/, "$1")) === 73 &&
        //   /^\/weaver\/weaver\.file\.FileDownload/.test(downloadURL) &&
        //   /&download=1/.test(downloadURL)
        // ) {
        //   frame.onload = () => {
        //     frame.onload = () => {};
        //     frame.src = downloadURL;
        //   };
        //   frame.src = downloadURL.replace(/&download=1/, "");
        // } else {
        // }
        var reg = new RegExp("^" + window.ecologyContentPath + "");
        downloadURL = reg.test(downloadURL)
          ? downloadURL
          : (window.ecologyContentPath || "") + downloadURL;
        if (Number(u.replace(/^.*Chrome\/([\d]+).*$/, "$1")) >= 73) {
          window.open(downloadURL);
        } else {
          frame.src = "";
          frame.src = downloadURL;
        }
      }
    };
    if (typeof this.props.onCustomDownload === "function") {
      this.props.onCustomDownload(downloadURL);
    } else if (typeof this.props.onCheckDownload === "function") {
      this.props.onCheckDownload(d, fn);
    } else {
      fn();
    }
  }
  open(url, d) {
    const fn = () => {
      var reg = new RegExp("^" + window.ecologyContentPath + "");
      url = reg.test(url) ? url : (window.ecologyContentPath || "") + url;
      openFullWindowHaveBar(url);
    };
    if (typeof this.props.onItemClick === "function") {
      this.props.onItemClick(url);
    } else if (typeof this.props.onCheckPreview === "function") {
      this.props.onCheckPreview(d, fn);
    } else {
      fn();
    }
  }
  onDrop = (p, newList) => {
    // this.setState({ [p]: newList });
    // WeaDragula modify the memory directy -> this.state
    if (p === "listT") this.onChange(newList);
  };
  getWeaDragulaProps = p => {
    const { autoUpload, listType } = this.props;
    let isDetail = autoUpload;
    if ("isDetail" in this.props) {
      isDetail = this.props.isDetail;
    }
    return {
      container: () => this.refs[p],
      datas: this.state[p],
      canDrag: target => {
        // set modal transform 'inherit' to fix position
        const modal = $(this.wrap).closest(".ant-modal.react-draggable");
        modal.length === 1 && (modal[0].style.transform = "inherit");
        return $(target).hasClass("wea-upload-move");
      },
      getKeyFromData: record => record.fileid || record.id,
      getKeyFromDom: r => $("span.wea-upload-move", r).attr("data-index"),
      onDrop: (...arg) => this.onDrop(p, ...arg),
      direction: !isDetail && listType === "img" ? "horizontal" : "vertical"
    };
  };
  onEdit = (p, v, d) => {
    let value = v;
    if (fileNameReg.test(value)) {
      value = v.replace(fileNameReg, "");
    }
    let newName = "";
    const newList = this.state[p].map(file => {
      const oname = file.filename || file.name;
      const str = oname.match(/\.[^\.]+$/);
      const name = `${value}${str ? str[0] : ""}`;
      const newFile = { ...file };
      delete newFile.WEA_UPLOAD_EDITABLE;
      if (
        ((file.fileid && file.fileid === d.fileid) ||
          (file.id && file.id === d.id)) &&
        value
      ) {
        newName = name;
        newFile.filename = name;
        newFile.name = name;
        if (p === "listB") {
          newFile.WEA_NATIVE_FILE.target_name = name;
          newFile.WEA_NATIVE_FILE.name = name;
        }
      }
      return newFile;
    });
    this.setState({ [p]: newList });
    if (p === "listT" && newName) {
      this.onChange(newList);
      callApi("/api/doc/acc/rename", "POST", {
        imagefileid: d.imagefileid || d.fileid,
        imagefilename: newName
      });
    }
    if (newName && typeof this.props.onFileNameEdit === "function") {
      this.props.onFileNameEdit(newName, d);
    }
  };
  canEdit = (p, d) => {
    this.setState({
      [p]: this.state[p].map(file => {
        const newFile = { ...file };
        if (
          (file.fileid && file.fileid === d.fileid) ||
          (file.id && file.id === d.id)
        ) {
          newFile.WEA_UPLOAD_EDITABLE = true;
          this.editInputTimer = setTimeout(() => {
            const wi = this.refs[p === "listT" ? d.fileid : d.id];
            if (wi && wi.refs.inputNormal) {
              wi.refs.inputNormal.refs.input.refs.input.focus();
              this.editInputTimer = clearTimeout(wi);
            }
            if (wi && wi.refs.textareaNormal) {
              wi.refs.textareaNormal.refs.input.refs.input.focus();
              wi.refs.textareaNormal.setCursorInEnd(
                wi.refs.textareaNormal.refs.input.refs.input
              );
              this.editInputTimer = clearTimeout(wi);
            }
          }, 0);
        }
        return newFile;
      })
    });
  };
  onEditSec = (params, showname) => {
    const { modifySecUrl, needModifyDocSec } = this.props;
    const { currentFile, editFile, listT } = this.state;
    let otherParams = {};
    if (needModifyDocSec) {
      otherParams = {
        ismodifydoc: 1,
        docid: currentFile.fileid
      };
    }
    callApi(modifySecUrl, "POST", {
      imagefileid: editFile,
      ...otherParams,
      ...params
    }).then(res => {
      if (res.api_status) {
        let currentFile;
        const newList = listT.map(item => {
          if (
            ((item.fileid && item.fileid === editFile) ||
              (item.imagefileid && item.imagefileid === editFile)) &&
            res.secretLevelValidityValue
          ) {
            currentFile = item;
            item.secretLevel = params.secretLevel;
            item.secretLevelValidityValue = res.secretLevelValidityValue;
            item.secretLevelValidity = params.secretLevelValidity;
          }
          return item;
        });
        this.onChange(newList);
        this.setState({
          listT: newList,
          editFile: "",
          visible: false,
          isEditSec: false,
          currentFile: {}
        });
        if (typeof this.props.onEditSecLevel === "function") {
          this.props.onEditSecLevel(res, editFile, currentFile, newList); //接口返回，修改的文件id，修改的文件数据，所有数据
        }
      }
    });
  };
  editSecLevel = d => {
    this.setState({
      visible: true,
      isEditSec: true,
      editFile: d.imagefileid || d.fileid,
      currentFile: d
    });
  };
  onForceUpdate = () => {
    const { showUploader, showUploadTime } = this.props;
    if (showUploader || showUploadTime) {
      this.forceUpdate();
    }
  };
  renderlistT() {
    const {
      listType,
      viewAttr,
      imgHeight,
      imgWidth,
      autoUpload,
      sortable,
      editable,
      showOrder,
      showUploader,
      showUploadTime,
      oneline,
      showHead,
      linkHrm,
      showEditButton,
      showLoadInFront,
      showFilesize,
      showFullName,
      showSecLevel,
      allowEditSec,
      ecId,
      casProtect,
      secLevelDisplayFormat
    } = this.props;
    let isDetail;
    if ("isDetail" in this.props) {
      isDetail = this.props.isDetail;
    } else {
      isDetail = autoUpload;
    }
    const { listT, width } = this.state;
    const reg = new RegExp("^" + window.ecologyContentPath + "");
    return (
      <div
        className="wea-upload-list"
        ref="listT"
        style={{ padding: listT.length > 0 ? "0 0 5px 0" : 0 }}
      >
        {listT.map((d, index) => {
          const {
            fileid,
            imgSrc,
            filelink,
            filename,
            filesize,
            loadlink = "",
            showLoad,
            showDelete,
            isImg,
            WEA_UPLOAD_EDITABLE,
            overflow = false,
            username,
            uploaddate,
            userid,
            secretLevel,
            secretLevelValidity,
            secretLevelValidityValue
          } = d;
          let showSecName = secretLevelValidityValue || "";
          if (casProtect && showSecLevel) {
            const secretLabel =
              showSecName.indexOf("★") !== -1
                ? showSecName.substring(0, showSecName.indexOf("★"))
                : showSecName;
            if (secLevelDisplayFormat !== "") {
              // 流程模块单独控制密级显示
              showSecName =
                secLevelDisplayFormat === "0"
                  ? secretLevelValidity
                    ? secretLabel + "★" + secretLevelValidity
                    : secretLabel
                  : secretLabel;
            }
          }
          const hasEditButton =
            viewAttr !== 1 && editable && showEditButton
              ? `wea-upload-list-item-file-hasedit${linkHrm ? "-linkhrm" : ""}`
              : "";
          const showNameOrTime =
            (showUploader || showUploadTime) && !isDetail && oneline
              ? `wea-upload-list-item-file-uploaded${linkHrm ? "-linkhrm" : ""}`
              : "";
          const imgBtnMagrinLeft =
            (imgWidth && imgWidth > 90 ? imgWidth + 10 : 100) / 4 - 8;
          const imgBtnMagrinRight =
            (imgWidth && imgWidth > 90 ? imgWidth + 10 : 100) / 4 - 5;
          // 文件名过长时，编辑图标与下载删除等距显示 宽度加大
          const itemOpsDivWidth =
            viewAttr !== 1 &&
            showDelete &&
            showLoad &&
            overflow &&
            editable &&
            showEditButton
              ? "67px"
              : (viewAttr !== 1 && showDelete) || showLoad
              ? "53px"
              : "0px";
          let inputRight = -42;
          let paddingRight = 115;
          if (showOrder) {
            inputRight = inputRight - 10;
            paddingRight += 10;
          }
          if (showLoadInFront) {
            inputRight = inputRight - 24;
            paddingRight += 24;
          }
          if (!imgSrc) {
            inputRight += 16;
            paddingRight = paddingRight - 10;
          }
          const inputRightPx = 0 - inputRight - 22;
          const imgDom = isDetail ? (
            <div
              className="wea-upload-imgs-item wea-upload-imgs-item-h"
              key={fileid}
              style={{ width, minWidth: imgWidth + 70, height: imgHeight + 10 }}
            >
              {viewAttr !== 1 && sortable ? (
                <span
                  data-index={fileid}
                  key={fileid}
                  className="icon-coms-move wea-upload-move cursor-pointer"
                />
              ) : null}
              <img
                ecId={`${ecId}_img@3xns4i@${fileid}`}
                className="formImgPlay"
                src={
                  reg.test(imgSrc)
                    ? imgSrc
                    : (window.ecologyContentPath || "") + imgSrc
                }
                onClick={e => this.playImg(d, e)}
                data-imgsrc={
                  reg.test(loadlink)
                    ? loadlink.replace("&download=1", "")
                    : (window.ecologyContentPath || "") +
                      loadlink.replace("&download=1", "")
                }
                style={{
                  width: imgWidth,
                  height: imgHeight,
                  cursor: "pointer"
                }}
              />
              <span
                style={{
                  position: "absolute",
                  right: 0,
                  top: 5,
                  width: 60,
                  lineHeight: `${imgHeight}px`
                }}
              >
                {viewAttr !== 1 && showDelete && (
                  <Icon
                    ecId={`${ecId}_Icon@z1i9nz@${fileid}`}
                    type="cross"
                    title={getLabel(91, "删除")}
                    style={{
                      float: "right",
                      cursor: "pointer",
                      fontSize: 10,
                      marginTop: imgHeight / 2 - 5,
                      marginRight: 10
                    }}
                    onClick={this.doDeleteT.bind(this, fileid)}
                  />
                )}
                {showLoad && (
                  <i
                    ecId={`${ecId}_i@k23m45@${fileid}`}
                    className="icon-coms-download wea-upload-icon"
                    title={getLabel(31156, "下载")}
                    style={{
                      float: "right",
                      fontSize: 16,
                      marginTop: imgHeight / 2 - 8,
                      marginRight: 10
                    }}
                    onClick={e => this.download(loadlink, d, e)}
                  />
                )}
              </span>
            </div>
          ) : (
            <div
              className="wea-upload-imgs-item wea-upload-imgs-item-v"
              key={fileid}
              style={{ width: imgWidth && imgWidth > 90 ? imgWidth + 10 : 100 }}
            >
              {viewAttr !== 1 && sortable ? (
                <span
                  data-index={fileid}
                  key={fileid}
                  className="icon-coms-move wea-upload-move cursor-pointer"
                />
              ) : null}
              <img
                ecId={`${ecId}_img@3b8ri8@${fileid}`}
                className="formImgPlay"
                src={
                  reg.test(imgSrc)
                    ? imgSrc
                    : (window.ecologyContentPath || "") + imgSrc
                }
                onClick={e => this.playImg(d, e)}
                data-imgsrc={
                  reg.test(loadlink)
                    ? loadlink.replace("&download=1", "")
                    : (window.ecologyContentPath || "") +
                      loadlink.replace("&download=1", "")
                }
                style={{
                  width: imgWidth,
                  height: imgHeight,
                  cursor: "pointer"
                }}
              />
              <p
                className="wea-upload-imgs-item-v-ops"
                style={{
                  textAlign:
                    showLoad === (viewAttr !== 1 && showDelete)
                      ? "left"
                      : "center"
                }}
              >
                {showLoad && (
                  <i
                    ecId={`${ecId}_i@zilzm0@${fileid}`}
                    className="icon-coms-download wea-upload-icon"
                    title={getLabel(31156, "下载")}
                    style={{
                      marginLeft:
                        viewAttr !== 1 && showDelete ? imgBtnMagrinLeft : 0
                    }}
                    onClick={e => this.download(loadlink, d, e)}
                  />
                )}
                {viewAttr !== 1 && showDelete && (
                  <Icon
                    ecId={`${ecId}_Icon@knwgka@${fileid}`}
                    type="cross"
                    title={getLabel(91, "删除")}
                    style={
                      showLoad
                        ? {
                            float: "right",
                            marginTop: 6,
                            fontSize: 10,
                            cursor: "pointer",
                            marginRight: imgBtnMagrinRight
                          }
                        : { marginTop: 6, fontSize: 10, cursor: "pointer" }
                    }
                    onClick={this.doDeleteT.bind(this, fileid)}
                  />
                )}
              </p>
            </div>
          );
          const heightStyle = showFullName
            ? { lineHeight: "20px", minHeight: "30px", paddingTop: "3px" }
            : { minHeight: "30px", lineHeight: "30px" };
          return listType === "img" ? (
            imgDom
          ) : (
            <div className="wea-upload-list-item" key={fileid}>
              <div
                className={`wea-upload-list-item-file wea-upload-list-item-file wea-upload-list-item-file-t${
                  isDetail ? "-nosize" : ""
                } wea-upload-list-item-file-t-f${
                  viewAttr === 1 &&
                  (showUploader || showUploadTime) &&
                  !isDetail &&
                  oneline
                    ? linkHrm
                      ? "onlyread wea-upload-list-item-file-t-flinkhrm"
                      : "onlyread"
                    : ""
                }`}
                // onMouseEnter={this.onForceUpdate}
                style={{ width, ...heightStyle }}
              >
                <div
                  className={
                    viewAttr !== 1 && editable && !WEA_UPLOAD_EDITABLE
                      ? `wea-upload-list-item-file-editable ${showNameOrTime} ${hasEditButton} ${
                          showFullName
                            ? "wea-upload-list-item-file-showfullname"
                            : ""
                        }`
                      : `${showNameOrTime} wea-upload-list-item-file-noedit`
                  }
                >
                  <div
                    className="wea-upload-list-content"
                    style={
                      showFullName
                        ? { whiteSpace: "normal" }
                        : { whiteSpace: "nowrap" }
                    }
                  >
                    <div style={{ display: "inline-block", float: "left" }}>
                      {showOrder && `${index + 1}.`}
                      {viewAttr !== 1 && sortable ? (
                        <span
                          data-index={fileid}
                          key={fileid}
                          className="icon-coms-move wea-upload-move cursor-pointer"
                        />
                      ) : null}
                      {showLoad && showLoadInFront && (
                        <i
                          ecId={`${ecId}_i@nr68da@${fileid}`}
                          className="icon-coms-download wea-upload-icon wea-upload-icon-loadfront"
                          title={getLabel(31156, "下载")}
                          style={{
                            fontSize: 15,
                            margin: "7px 6px 0 3px"
                          }}
                          onClick={e => this.download(loadlink, d, e)}
                        />
                      )}
                      {imgSrc && (
                        <img
                          src={
                            reg.test(imgSrc)
                              ? imgSrc
                              : (window.ecologyContentPath || "") + imgSrc
                          }
                          style={{ width: 16, height: 16 }}
                        />
                      )}
                    </div>
                    {viewAttr !== 1 && WEA_UPLOAD_EDITABLE ? (
                      showFullName ? (
                        <React.Fragment>
                          <WeaTextarea
                            ref={fileid}
                            ecId={`${ecId}_WeaTextarea@pjtu61@${fileid}`}
                            style={{
                              right: inputRight,
                              paddingTop: "2px",
                              paddingRight: "44px",
                              top: "-20px",
                              backgroundColor: "#fff"
                            }}
                            title={`${getLabel(
                              528241,
                              "文件名不能包含"
                            )} \\ / : * ? " < > |`}
                            value={filename.replace(/\.[^\.]+$/, "")}
                            onBlur={v => this.onEdit("listT", v, d)}
                            onKeyDown={e => {
                              if (e.keyCode && e.keyCode === 13) {
                                this.onEdit("listT", e.target.value, d);
                                e.preventDefault();
                              }
                            }}
                          />
                          {((showUploader && !oneline && username) ||
                            (showUploadTime && !oneline && uploaddate) ||
                            (casProtect && showSecLevel)) && (
                            <div
                              className="wea-upload-list-item-twoline"
                              style={{ top: -10, right: -42 }}
                            >
                              {showSecLevel &&
                                casProtect &&
                                !oneline &&
                                showSecName && (
                                  <div className="wea-upload-list-item-uploader">
                                    {viewAttr !== 1 && allowEditSec ? (
                                      <React.Fragment>
                                        <WeaPopoverHrm />
                                        <a
                                          style={{
                                            color: "#999",
                                            // marginLeft: 8,
                                            cursor: "pointer"
                                          }}
                                          // href={`javaScript:openhrm(${userid});`}
                                          ecId={`${ecId}_a@8ayucr@${fileid}`}
                                          onClick={() => this.editSecLevel(d)}
                                        >
                                          {showSecName}
                                        </a>
                                      </React.Fragment>
                                    ) : (
                                      <span
                                        style={{
                                          color: "#999"
                                          // marginLeft: 8,
                                        }}
                                      >
                                        {showSecName}
                                      </span>
                                    )}
                                  </div>
                                )}
                              {showUploader && !oneline && username && (
                                <div className="wea-upload-list-item-uploader">
                                  {userid ? (
                                    <React.Fragment>
                                      <WeaPopoverHrm />
                                      <a
                                        style={{
                                          color: "#999",
                                          // marginLeft: 8,
                                          cursor: "pointer"
                                        }}
                                        ecId={`${ecId}_a@9brja9@${fileid}`}
                                        href={`javaScript:openhrm(${userid});`}
                                        onClick={e => window.pointerXY(e)}
                                      >
                                        {username}
                                      </a>
                                    </React.Fragment>
                                  ) : (
                                    <span
                                      style={{
                                        color: "#999"
                                        // marginLeft: 8,
                                      }}
                                    >
                                      {username}
                                    </span>
                                  )}
                                </div>
                              )}
                              {showUploadTime && !oneline && uploaddate && (
                                <div className="wea-upload-list-item-uploadtime">
                                  <span
                                    style={{
                                      color: "#999"
                                      // marginLeft: 8
                                    }}
                                  >
                                    {uploaddate}
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                        </React.Fragment>
                      ) : (
                        <WeaInput
                          ecId={`${ecId}_WeaInput@xb6yon@${fileid}`}
                          ref={fileid}
                          style={{
                            right: inputRight,
                            paddingRight: paddingRight,
                            minHeight: "28px"
                          }}
                          title={`${getLabel(
                            528241,
                            "文件名不能包含"
                          )} \\ / : * ? " < > |`}
                          value={filename.replace(/\.[^\.]+$/, "")}
                          onBlur={v => this.onEdit("listT", v, d)}
                          onKeyDown={e => {
                            if (e.keyCode && e.keyCode === 13) {
                              this.onEdit("listT", e.target.value, d);
                              e.preventDefault();
                            }
                          }}
                        />
                      )
                    ) : (
                      <div
                        style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                      >
                        {isImg ? (
                          <a
                            ecId={`${ecId}_a@snyv1p@${fileid}`}
                            // href="javascript:void(0);"
                            title={filename}
                            onClick={e => this.playImg(d, e)}
                            className="formImgPlay wea-field-link"
                            src={
                              reg.test(filelink)
                                ? filelink
                                : (window.ecologyContentPath || "") + filelink
                            }
                            data-imgsrc={
                              reg.test(loadlink)
                                ? loadlink.replace("&download=1", "")
                                : (window.ecologyContentPath || "") +
                                  loadlink.replace("&download=1", "")
                            }
                            style={{ wordBreak: "break-all" }}
                          >
                            {filename}
                          </a>
                        ) : (
                          <a
                            ecId={`${ecId}_a@et8f5f@${fileid}`}
                            href="javascript:void(0);"
                            title={filename}
                            onClick={this.open.bind(
                              this,
                              reg.test(filelink)
                                ? filelink
                                : (window.ecologyContentPath || "") + filelink,
                              d
                            )}
                            className="wea-field-link"
                            style={{ wordBreak: "break-all" }}
                          >
                            {filename}
                          </a>
                        )}
                        {viewAttr !== 1 &&
                          editable &&
                          !WEA_UPLOAD_EDITABLE &&
                          showEditButton &&
                          showFullName && (
                            <i
                              ecId={`${ecId}_i@jrow9c@${fileid}`}
                              className={`icon-coms-edit cursor-pointer ${
                                showFullName ? "showfullname-edit" : ""
                              }`}
                              style={{
                                fontSize: 15
                              }}
                              onClick={() => this.canEdit("listT", d)}
                              title={getLabel(93, "编辑")}
                            />
                          )}
                        {((showUploader && !oneline && username) ||
                          (showUploadTime && !oneline && uploaddate) ||
                          (casProtect && showSecLevel)) &&
                          showFullName && (
                            <div className="wea-upload-list-item-twoline">
                              {showSecLevel &&
                                casProtect &&
                                !oneline &&
                                showSecName && (
                                  <div className="wea-upload-list-item-uploader">
                                    {viewAttr !== 1 && allowEditSec ? (
                                      <React.Fragment>
                                        <WeaPopoverHrm
                                          ecId={`${ecId}_WeaPopoverHrm@fz0im8@${fileid}`}
                                        />
                                        <a
                                          ecId={`${ecId}_a@ral85r@${fileid}`}
                                          style={{
                                            color: "#999",
                                            cursor: "pointer"
                                          }}
                                          onClick={() => this.editSecLevel(d)}
                                        >
                                          {showSecName}
                                        </a>
                                      </React.Fragment>
                                    ) : (
                                      <span
                                        style={{
                                          color: "#999"
                                        }}
                                      >
                                        {showSecName}
                                      </span>
                                    )}
                                  </div>
                                )}
                              {showUploader && !oneline && username && (
                                <div className="wea-upload-list-item-uploader">
                                  {userid ? (
                                    <React.Fragment>
                                      <WeaPopoverHrm
                                        ecId={`${ecId}_WeaPopoverHrm@lh1gaj@${fileid}`}
                                      />
                                      <a
                                        ecId={`${ecId}_a@p4vttw@${fileid}`}
                                        style={{
                                          color: "#999",
                                          // marginLeft: 8,
                                          cursor: "pointer"
                                        }}
                                        href={`javaScript:openhrm(${userid});`}
                                        onClick={e => window.pointerXY(e)}
                                      >
                                        {username}
                                      </a>
                                    </React.Fragment>
                                  ) : (
                                    <span
                                      style={{
                                        color: "#999"
                                        // marginLeft: 8,
                                      }}
                                    >
                                      {username}
                                    </span>
                                  )}
                                </div>
                              )}
                              {showUploadTime && !oneline && uploaddate && (
                                <div className="wea-upload-list-item-uploadtime">
                                  <span
                                    style={{
                                      color: "#999"
                                      // marginLeft: 8
                                    }}
                                  >
                                    {uploaddate}
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                      </div>
                    )}
                    {/* {!autoUpload && ( */}
                    {showFilesize && (
                      <div className="wea-upload-list-item-filesize">
                        <span style={{ color: "#999", marginLeft: 8 }}>
                          {filesize}
                        </span>
                      </div>
                    )}
                    {/* )} */}
                  </div>
                  {viewAttr !== 1 &&
                    editable &&
                    !WEA_UPLOAD_EDITABLE &&
                    showEditButton &&
                    !showFullName && (
                      <i
                        ecId={`${ecId}_i@qftb3f@${fileid}`}
                        className={`icon-coms-edit cursor-pointer`}
                        style={{
                          fontSize: 15
                        }}
                        onClick={() => this.canEdit("listT", d)}
                        title={getLabel(93, "编辑")}
                      />
                    )}
                  {!WEA_UPLOAD_EDITABLE &&
                    showUploader &&
                    !isDetail &&
                    oneline && (
                      <div
                        className={`wea-upload-list-item-uploader${
                          linkHrm ? "-linkhrm" : ""
                        }`}
                      >
                        {userid ? (
                          <React.Fragment>
                            <WeaPopoverHrm />
                            <a
                              ecId={`${ecId}_a@b3jepf@${fileid}`}
                              style={{
                                color: "#999",
                                marginLeft: 12,
                                cursor: "pointer"
                              }}
                              href={`javaScript:openhrm(${userid});`}
                              onClick={e => window.pointerXY(e)}
                            >
                              {username}
                            </a>
                          </React.Fragment>
                        ) : (
                          <span
                            style={{
                              color: "#999",
                              marginLeft: 12
                            }}
                          >
                            {username}
                          </span>
                        )}
                      </div>
                    )}
                  {!WEA_UPLOAD_EDITABLE &&
                    showUploadTime &&
                    !isDetail &&
                    oneline && (
                      <div
                        className={`wea-upload-list-item-uploadtime${
                          linkHrm ? "-linkhrm" : ""
                        }`}
                      >
                        <span style={{ color: "#999", marginLeft: 8 }}>
                          {uploaddate}
                        </span>
                      </div>
                    )}
                  <div
                    className="wea-upload-list-item-ops"
                    style={{ width: itemOpsDivWidth }}
                  >
                    {viewAttr !== 1 &&
                    editable &&
                    overflow &&
                    !WEA_UPLOAD_EDITABLE &&
                    showEditButton ? (
                      <i
                        ecId={`${ecId}_i@qlsk8a@${fileid}`}
                        className="icon-coms-edit cursor-pointer"
                        style={{
                          fontSize: 15
                        }}
                        onClick={() => this.canEdit("listT", d)}
                        title={getLabel(93, "编辑")}
                      />
                    ) : null}
                    {viewAttr !== 1 && showDelete && (
                      <Icon
                        ecId={`${ecId}_Icon@sze8ep@${fileid}`}
                        type="cross"
                        title={getLabel(91, "删除")}
                        style={{
                          float: "right",
                          margin: "7px 5px 0 3px",
                          cursor: "pointer",
                          fontSize: 15
                        }}
                        onClick={this.doDeleteT.bind(this, fileid)}
                      />
                    )}
                    {showLoad && !showLoadInFront && (
                      <i
                        ecId={`${ecId}_i@krgpwf@${fileid}`}
                        className="icon-coms-download wea-upload-icon"
                        title={getLabel(31156, "下载")}
                        style={{
                          float: "right",
                          fontSize: 15,
                          margin: "7px 6px 0 3px"
                        }}
                        onClick={e => this.download(loadlink, d, e)}
                      />
                    )}
                  </div>
                </div>
              </div>
              {((showUploader && !oneline && username) ||
                (showUploadTime && !oneline && uploaddate) ||
                (casProtect && showSecLevel)) &&
                !showFullName && (
                  <div
                    className="wea-upload-list-item-twoline"
                    style={{ paddingLeft: inputRightPx }}
                  >
                    {showSecLevel && casProtect && !oneline && showSecName && (
                      <div className="wea-upload-list-item-uploader">
                        {viewAttr !== 1 && allowEditSec ? (
                          <React.Fragment>
                            <WeaPopoverHrm
                              ecId={`${ecId}_WeaPopoverHrm@0xikii@${fileid}`}
                            />
                            <a
                              ecId={`${ecId}_a@njw49v@${fileid}`}
                              style={{
                                color: "#999",
                                // marginLeft: 8,
                                cursor: "pointer"
                              }}
                              // href={`javaScript:openhrm(${userid});`}
                              onClick={() => this.editSecLevel(d)}
                            >
                              {showSecName}
                            </a>
                          </React.Fragment>
                        ) : (
                          <span
                            style={{
                              color: "#999"
                              // marginLeft: 8,
                            }}
                          >
                            {showSecName}
                          </span>
                        )}
                      </div>
                    )}
                    {showUploader && !oneline && username && (
                      <div className="wea-upload-list-item-uploader">
                        {userid ? (
                          <React.Fragment>
                            <WeaPopoverHrm
                              ecId={`${ecId}_WeaPopoverHrm@9ykess@${fileid}`}
                            />
                            <a
                              ecId={`${ecId}_a@4p671x@${fileid}`}
                              style={{
                                color: "#999",
                                // marginLeft: 8,
                                cursor: "pointer"
                              }}
                              href={`javaScript:openhrm(${userid});`}
                              onClick={e => window.pointerXY(e)}
                            >
                              {username}
                            </a>
                          </React.Fragment>
                        ) : (
                          <span
                            style={{
                              color: "#999"
                              // marginLeft: 8,
                            }}
                          >
                            {username}
                          </span>
                        )}
                      </div>
                    )}
                    {showUploadTime && !oneline && uploaddate && (
                      <div className="wea-upload-list-item-uploadtime">
                        <span
                          style={{
                            color: "#999"
                            // marginLeft: 8
                          }}
                        >
                          {uploaddate}
                        </span>
                      </div>
                    )}
                  </div>
                )}
            </div>
          );
        })}
      </div>
    );
  }
  renderlistB() {
    const { autoUpload, sortable, editable, ecId } = this.props;
    const { listB, width } = this.state;
    let isDetail;
    if ("isDetail" in this.props) {
      isDetail = this.props.isDetail;
    } else {
      isDetail = autoUpload;
    }
    const progressWidth = width - 20;
    return (
      <div
        className="wea-upload-list"
        ref="listB"
        style={{ padding: listB.length > 0 ? "0 0 5px 0" : 0 }}
      >
        {listB.map(d => {
          if (!d) {
            return;
          }
          const {
            name,
            id,
            progress,
            showProgress,
            error,
            progressStatus,
            WEA_UPLOAD_EDITABLE
          } = d;
          const status =
            error && progressStatus ? { status: progressStatus } : {};
          // 二开:有错误信息时不显示当前行 ecode控制
          const errorClass =
            error == getLabel(125378, "文件过大")
              ? "wea-upload-list-item-nodisplay"
              : "";
          return (
            <div className={`wea-upload-list-item ${errorClass}`} key={id}>
              <div
                ecId={`${ecId}_div@4g568y@${id}`}
                className={`wea-upload-list-item-file wea-upload-list-item-file-b`}
                style={error ? { width, padding: "0 80px 0 0" } : { width }}
                onClick={() => {
                  const file = d.getNative();
                  const currentWindow = this.getCurrentWindow();
                  if (
                    currentWindow.e9ecComConfig &&
                    currentWindow.e9ecComConfig.weaUploadLocalDownload
                  ) {
                    if ("msSaveOrOpenBlob" in navigator) {
                      window.navigator.msSaveOrOpenBlob(file, file.name);
                    } else if (currentWindow.URL) {
                      const url = currentWindow.URL.createObjectURL(file);
                      // this.download(url);
                      var a = document.createElement("a");
                      var filename = file.name;
                      a.href = url;
                      a.download = filename;
                      a.click();
                      currentWindow.URL.revokeObjectURL(url);
                    }
                  }
                }}
              >
                <div
                  className={
                    editable && !WEA_UPLOAD_EDITABLE
                      ? "wea-upload-list-item-file-editable"
                      : "wea-upload-list-item-file-noedit"
                  }
                >
                  <div>
                    {!isDetail && sortable ? (
                      <span
                        data-index={id}
                        key={id}
                        className="icon-coms-move wea-upload-move cursor-pointer"
                      />
                    ) : null}
                    {!isDetail && (
                      <Icon
                        ecId={`${ecId}_Icon@plv4qm@${id}`}
                        type="paper-clip"
                        style={{ marginRight: 5 }}
                      />
                    )}
                    {WEA_UPLOAD_EDITABLE ? (
                      <WeaInput
                        ecId={`${ecId}_WeaInput@oj076m@${id}`}
                        ref={id}
                        title={`${getLabel(
                          528241,
                          "文件名不能包含"
                        )} \\ / : * ? " < > |`}
                        value={name.replace(/\.[^\.]+$/, "")}
                        onBlur={v => this.onEdit("listB", v, d)}
                        onKeyDown={e => {
                          if (e.keyCode && e.keyCode === 13) {
                            this.onEdit("listB", e.target.value, d);
                            e.preventDefault();
                          }
                        }}
                      />
                    ) : (
                      <span style={{ cursor: "pointer" }}>{name}</span>
                    )}
                  </div>
                  {/* {editable ? (
                    <i
                      className="icon-coms-edit cursor-pointer"
                      onClick={() => this.canEdit("listB", d)}
                      title={getLabel(387789, "编辑")}
                    />
                  ) : null} */}
                </div>
                {error && (
                  <span
                    style={{
                      display: "inline-block",
                      color: "#f00",
                      position: "absolute",
                      right: 0,
                      top: 0
                    }}
                  >{`（${error}）`}</span>
                )}
                {!showProgress && (
                  <Icon
                    ecId={`${ecId}_Icon@6gtpza@${id}`}
                    type="cross"
                    className="wea-upload-list-item-del"
                    style={{ fontSize: 10 }}
                    title={getLabel(91, "删除")}
                    onClick={e => {
                      this.doDeleteB(id);
                      e.stopPropagation();
                    }}
                  />
                )}
              </div>
              {showProgress && (
                <div>
                  <Progress
                    style={{ width: progressWidth }}
                    percent={progress}
                    strokeWidth={3}
                    {...status}
                    ecId={`${ecId}_Progress@ixwg5r@${id}`}
                  />
                  <Icon
                    ecId={`${ecId}_Icon@sucw9e@${id}`}
                    type="cross"
                    className="wea-upload-list-item-del"
                    style={{ fontSize: 10 }}
                    title={getLabel(91, "删除")}
                    onClick={e => {
                      this.doDeleteB(id);
                      e.stopPropagation();
                    }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }
  getDefaultListB = () => {
    const { showListTop, viewAttr, sortable, ecId } = this.props;
    if (showListTop) {
      if (viewAttr !== 1 && sortable) {
        return (
          <WeaDragula
            {...this.getWeaDragulaProps("listT")}
            ecId={`${ecId}_WeaDragula@6q76o9`}
          >
            {this.renderlistT()}
          </WeaDragula>
        );
      }
      return this.renderlistT();
    }
    return null;
  };
  checkSecLevel = () => {
    const { casProtect, secLevel, secLevelInfo } = this.props;
    if (!casProtect || casProtect == "false" || secLevel == "4") return;
    if (secLevel) {
      this.setState({ visible: true });
    } else if (casProtect) {
      message.error(secLevelInfo);
    }
  };
  changeVisible = visible => {
    // this.setState({ visible });
  };
  changeSensiVisible = visible => {
    this.setState({ sensitiveVisible: visible, sensitiveList: [] });
    if (!visible) {
      // 修复富文本上传敏感词提示框自动消失问题
      typeof this.props.onUploading === "function" &&
        this.props.onUploading("uploaded");
    }
  };
  onSave = params => {
    const { uploadParams, uploadId } = this.props;
    const { containerId } = this.state;
    const resetOptions = {};
    const jq = this.getCurrentJQuery();
    resetOptions.multipart_params = {
      ...uploadParams,
      ...params,
      ts: new Date().getTime()
    };
    Object.keys(resetOptions).length > 0 &&
      this.resetUploaderOption(resetOptions, false);
    console.log("secSave", params);
    if (this.isIE9) {
      jq(`#container_${uploadId}_${containerId} object`).css(
        "display",
        "block"
      );
      jq(`#container_${uploadId}_${containerId} object`).click();
    } else {
      // jq(`#container_${uploadId}_${containerId} input`).attr("disabled", false);
      // jq(`#container_${uploadId}_${containerId} input`).click();

      jq(`#container_${uploadId}_${containerId} input`).attr("disabled", false);
      // 国产操做系统麒麟银行火狐浏览器中，改变 dom disabled 后立即触发 click 事件是不可行的
      // 这里加个延迟，当 dom 的 disabled 确实改变为了 false 后，再触发 click
      let In = setInterval(() => {
        if (
          jq(`#container_${uploadId}_${containerId} input`).attr("disabled") !==
            "disabled" ||
          jq(`#container_${uploadId}_${containerId} input`).attr("disabled") !==
            true
        ) {
          jq(`#container_${uploadId}_${containerId} input`).click();
          this.filePicker = true;
          clearInterval(In);
        }
      }, 100);
    }
  };
  cancelEdit = () => {
    // this.setState({ isEditSec: false, editFile: "", currentFile: {} });
    this.setState({
      isEditSec: false,
      editFile: "",
      currentFile: {},
      visible: false
    });
  };
  render() {
    const {
      uploadId,
      uploadUrl,
      category,
      viewAttr,
      showBatchLoad,
      value,
      maxUploadSize,
      mixUploadSize,
      btnSize,
      batchLoadUrl,
      showClearAll,
      showUpload,
      errorMsg,
      style,
      children,
      RenderList,
      RenderListB,
      useDefaultListB,
      showListTop,
      showListBottom,
      sortable,
      maxFilesNumber,
      showCancleUpload,
      className,
      showScan,
      showHead,
      oneline,
      listType,
      autoUpload,
      customButton,
      requiredInfo,
      showFilesize,
      secLevel,
      ecId,
      casProtect
    } = this.props;
    const title = this.props.title || getLabel(128095, "上传附件");
    const {
      listT,
      listB,
      containerId,
      scanLoading,
      width,
      visible,
      isEditSec,
      currentFile,
      sensitiveVisible,
      sensitiveList
    } = this.state;
    let isDetail;
    if ("isDetail" in this.props) {
      isDetail = this.props.isDetail;
    } else {
      isDetail = autoUpload;
    }
    const disabled =
      maxFilesNumber === 0 ||
      uploadUrl === "" ||
      viewAttr === 1 ||
      category === "";
    const required = viewAttr === 3 && listB.length === 0 && listT.length === 0;
    const req = classNames({
      required: required
    });
    const notShow = errorMsg !== "" || uploadUrl === "" || category === ""; //将提醒组件使用者使用时哪些props可能未设置或未设置正确
    let btn = null;
    if (children) {
      btn = notShow ? (
        <span
          ecId={`${ecId}_span@ikshgk`}
          onClick={e => {
            message.error(
              uploadUrl === "" && viewAttr !== 1
                ? getLabel(385922, "请设置文件上传服务器地址!")
                : category === "" && viewAttr !== 1
                ? getLabel(385923, "请设置文件上传目录!")
                : "",
              1000
            );
            const timer = setTimeout(() => {
              message.destroy();
              clearTimeout(timer);
            }, 1000);
            e.stopPropagation && e.stopPropagation();
            e.preventDefault && e.preventDefault();
            e.nativeEvent && e.nativeEvent.preventDefault();
          }}
        >
          {children}
        </span>
      ) : (
        <span
          ecId={`${ecId}_span@6czqi4`}
          onClick={e => {
            if (
              ua.browser === "IE" &&
              parseInt(ua.version) < 10 &&
              !flashChecker().f
            ) {
              confirm({
                title: getLabel(127354, "警告"),
                content: getLabel(
                  385924,
                  "您的IE尚未安装flash插件，需安装后才能使用上传功能，现在安装？"
                ),
                onOk: () => {
                  window.open("http://get.adobe.com/cn/flashplayer/");
                }
              });
            }
            // e.stopPropagation && e.stopPropagation();
            // e.preventDefault && e.preventDefault();
            e.nativeEvent && e.nativeEvent.preventDefault();
          }}
        >
          {children}{" "}
        </span>
      );
    }
    const listNull = listT.length === 0 && listB.length === 0;
    const cls = classNames({
      [`${className}`]: className,
      "wea-field": /^field/.test(this.props.fieldName)
    });
    let maxUploadSizeInfo = getLabel(385926, "最大{max}M/个");
    maxUploadSizeInfo = maxUploadSizeInfo.replace("{max}", maxUploadSize);
    let mixUploadSizeInfo = getLabel(506196, "最小{mix}M/个");
    mixUploadSizeInfo = mixUploadSizeInfo.replace("{mix}", mixUploadSize);
    return (
      <div
        className={`wea-upload ${cls}`}
        id={`${uploadId}_${containerId}`}
        style={style}
        ref="wrap"
      >
        {RenderList ? (
          <RenderList
            ecId={`${ecId}_RenderList@iuxa4d`}
            datas={{ listT, listB }}
          />
        ) : (
          ""
        )}
        {children ? (
          <div
            id={`container_${uploadId}_${containerId}`}
            className="wea-upload-container"
          >
            <span
              ecId={`${ecId}_span@gd3pdc`}
              id={category ? `browsebtn_${uploadId}_${containerId}` : ""}
              onClick={e => this.checkSecLevel(e)}
              style={{ display: "inline-block" }}
            >
              {btn}
            </span>
            <input
              ecId={`${ecId}_input@k0458z`}
              type="hidden"
              name={uploadId}
              id={uploadId}
              value={value}
            />
            {required && (
              <span
                className="wea-required-e9"
                style={
                  requiredInfo ? { paddingLeft: "8px", top: 0 } : { top: 0 }
                }
              >
                {requiredInfo}
                <img
                  src={`${window.ecologyContentPath ||
                    ""}/images/BacoError_wev9.png`}
                  align="middle"
                />
              </span>
            )}
            <iframe
              ref={`download_${uploadId}_${containerId}`}
              style={{ display: "none" }}
            />
          </div>
        ) : (
          <span>
            <div>
              {showListTop ? (
                viewAttr !== 1 && sortable ? (
                  <React.Fragment>
                    {showHead &&
                      oneline &&
                      !isDetail &&
                      listT.length > 0 &&
                      listType !== "img" && (
                        <div
                          className="wea-upload-list-thead"
                          style={{ width }}
                        >
                          <div className="wea-upload-list-thead-filename">
                            {getLabel(23752, "附件名称")}
                          </div>
                          <div className="wea-upload-list-thead-username">
                            {getLabel(26083, "上传人")}
                          </div>
                          <div className="wea-upload-list-thead-uploadtime">
                            {getLabel(23068, "上传时间")}
                          </div>
                          {showFilesize && (
                            <div className="wea-upload-list-thead-filesize">
                              {getLabel(2036, "大小")}
                            </div>
                          )}
                        </div>
                      )}
                    <WeaDragula
                      {...this.getWeaDragulaProps("listT")}
                      ecId={`${ecId}_WeaDragula@7krxtv`}
                    >
                      {this.renderlistT()}
                    </WeaDragula>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {showHead &&
                      oneline &&
                      !isDetail &&
                      listT.length > 0 &&
                      listType !== "img" && (
                        <div
                          className="wea-upload-list-thead"
                          style={{ width }}
                        >
                          <div className="wea-upload-list-thead-filename">
                            {getLabel(23752, "附件名称")}
                          </div>
                          <div className="wea-upload-list-thead-username">
                            {getLabel(26083, "上传人")}
                          </div>
                          <div className="wea-upload-list-thead-uploadtime">
                            {getLabel(23068, "上传时间")}
                          </div>
                          {showFilesize && (
                            <div className="wea-upload-list-thead-filesize">
                              {getLabel(2036, "大小")}
                            </div>
                          )}
                        </div>
                      )}
                    {this.renderlistT()}
                  </React.Fragment>
                )
              ) : null}
              {errorMsg !== "" ? (
                <span style={{ color: "#f00" }}>{errorMsg}</span>
              ) : uploadUrl === "" && viewAttr !== 1 ? (
                <span style={{ color: "#f00" }}>
                  {getLabel(385922, "请设置文件上传服务器地址!")}
                </span>
              ) : category === "" && viewAttr !== 1 ? (
                <span style={{ color: "#f00" }}>
                  {getLabel(385923, "请设置文件上传目录!")}
                </span>
              ) : (
                ""
              )}
              <div
                className="wea-upload-container"
                style={
                  notShow
                    ? {
                        display: "inline-block",
                        width: 0,
                        height: 0,
                        overflow: "hidden"
                      }
                    : viewAttr === 1 && (!showBatchLoad || listNull)
                    ? {
                        display: "none"
                      }
                    : {}
                }
              >
                {btnSize === "small" ? (
                  <span
                    style={{
                      display: "inline-block",
                      verticalAlign: "middle"
                      // position: "relative",
                      // top: 4
                    }}
                  >
                    <span
                      id={`container_${uploadId}_${containerId}`}
                      style={
                        viewAttr === 1
                          ? {
                              display: "inline-block",
                              width: 0,
                              height: 0,
                              overflow: "hidden"
                            }
                          : {}
                      }
                    >
                      {showUpload && (
                        <i
                          ecId={`${ecId}_i@c6eoju`}
                          id={`browsebtn_${uploadId}_${containerId}`}
                          className="icon-coms-AddTo wea-upload-icon"
                          title={title}
                          onClick={e => this.checkSecLevel(e)}
                          style={{ margin: "0 5px 5px 0", float: "left" }}
                        />
                      )}
                      {customButton !== null ? (
                        <span
                          ecId={`${ecId}_span@49bgv3`}
                          onClick={() =>
                            typeof this.props.customClick === "function" &&
                            this.props.customClick(this.uploader)
                          }
                        >
                          {customButton}
                        </span>
                      ) : null}
                      {showClearAll && !listNull && (
                        <Button
                          ecId={`${ecId}_Button@sgvb0a`}
                          type="ghost"
                          disabled={listB.length === 0}
                          shape="circle-outline"
                          icon="cross"
                          title={getLabel(385925, "清除所有")}
                          style={{
                            margin: "0 5px 5px 0",
                            width: 25,
                            height: 23
                          }}
                          onClick={this.clearAllFiles}
                        />
                      )}
                      {showCancleUpload && (
                        <Button
                          ecId={`${ecId}_Button@fyl20v`}
                          type="ghost"
                          disabled={listB.length === 0}
                          shape="circle-outline"
                          icon="cross"
                          title={getLabel(126306, "取消上传")}
                          style={{
                            margin: "0 5px 5px 0",
                            width: 25,
                            height: 23
                          }}
                          onClick={this.cancleUpload}
                        />
                      )}
                    </span>
                    {showBatchLoad && !listNull && (
                      <Button
                        ecId={`${ecId}_Button@8rk3o3`}
                        type="ghost"
                        shape="circle-outline"
                        icon="download"
                        title={getLabel(32405, "全部下载")}
                        style={{ margin: "0 5px 5px 0" }}
                        onClick={this.download.bind(this, batchLoadUrl, listT)}
                      />
                    )}
                  </span>
                ) : (
                  <span>
                    <span
                      id={`container_${uploadId}_${containerId}`}
                      style={
                        viewAttr === 1
                          ? {
                              display: "inline-block",
                              width: 0,
                              height: 0,
                              overflow: "hidden"
                            }
                          : {}
                      }
                    >
                      {showUpload && (
                        <Button
                          ecId={`${ecId}_Button@2yh7pb`}
                          disabled={disabled}
                          type="ghost"
                          id={`browsebtn_${uploadId}_${containerId}`}
                          onClick={e => this.checkSecLevel(e)}
                          style={{ margin: "0 5px 5px 0" }}
                        >
                          <Icon ecId={`${ecId}_Icon@6i27sr`} type="upload" />{" "}
                          {title}
                        </Button>
                      )}
                      {customButton !== null ? (
                        <span
                          ecId={`${ecId}_span@v1rscl`}
                          onClick={() =>
                            typeof this.props.customClick === "function" &&
                            this.props.customClick(this.uploader)
                          }
                        >
                          {customButton}
                        </span>
                      ) : null}
                      {showClearAll && (
                        <Button
                          ecId={`${ecId}_Button@mormdo`}
                          disabled={listB.length === 0}
                          type="ghost"
                          style={{ margin: "0 5px 5px 0" }}
                          onClick={this.clearAllFiles.bind(this)}
                        >
                          <Icon ecId={`${ecId}_Icon@x656f4`} type="cross" />{" "}
                          {getLabel(385925, "清除所有")}
                        </Button>
                      )}
                      {showCancleUpload && (
                        <Button
                          ecId={`${ecId}_Button@s83w7p`}
                          disabled={listB.length === 0}
                          type="ghost"
                          style={{ margin: "0 5px 5px 0" }}
                          onClick={this.cancleUpload}
                        >
                          <Icon ecId={`${ecId}_Icon@z31r7k`} type="cross" />{" "}
                          {getLabel(126306, "取消上传")}
                        </Button>
                      )}
                    </span>
                    {showBatchLoad && !listNull && (
                      <Button
                        ecId={`${ecId}_Button@zum1ki`}
                        type="ghost"
                        style={{ margin: "0 5px 5px 0" }}
                        onClick={this.download.bind(this, batchLoadUrl, listT)}
                      >
                        <Icon ecId={`${ecId}_Icon@1uyq9l`} type="download" />{" "}
                        {getLabel(32405, "全部下载")}
                      </Button>
                    )}
                  </span>
                )}
                <span
                  // className={`${req}`}
                  style={{
                    position: "relative",
                    display: "inline-block",
                    marginBottom: 5,
                    marginRight: required ? 15 : 0
                  }}
                >
                  {viewAttr !== 1 && !!maxUploadSize && (
                    <span>{maxUploadSizeInfo}</span>
                  )}
                  {viewAttr !== 1 && !!mixUploadSize && (
                    <span>&nbsp;{mixUploadSizeInfo}</span>
                  )}
                  {required && (
                    <span
                      className="wea-required-e9"
                      style={
                        requiredInfo
                          ? { paddingLeft: "8px", top: 0 }
                          : { top: 0 }
                      }
                    >
                      {requiredInfo}
                      <img
                        src={`${window.ecologyContentPath ||
                          ""}/images/BacoError_wev9.png`}
                        align="middle"
                      />
                    </span>
                  )}
                </span>
              </div>
              {showListBottom ? (
                viewAttr !== 1 && sortable ? (
                  <WeaDragula
                    {...this.getWeaDragulaProps("listB")}
                    ecId={`${ecId}_WeaDragula@jx5myj`}
                  >
                    {this.renderlistB()}
                  </WeaDragula>
                ) : (
                  this.renderlistB()
                )
              ) : null}
              <input
                ecId={`${ecId}_input@3psgqp`}
                type="hidden"
                name={uploadId}
                id={uploadId}
                value={value}
              />
              <iframe
                ref={`download_${uploadId}_${containerId}`}
                style={{ display: "none" }}
              />
            </div>
          </span>
        )}
        {useDefaultListB ? (
          this.getDefaultListB()
        ) : RenderListB ? (
          <RenderListB
            ecId={`${ecId}_RenderListB@kpy66p`}
            datas={{ listT, listB }}
          />
        ) : (
          ""
        )}
        {casProtect && (
          <SecLevelDialog
            ecId={`${ecId}_SecLevelDialog@acvypt`}
            visible={visible}
            isEditSec={isEditSec}
            secLevel={secLevel}
            changeVisible={this.changeVisible}
            onSave={this.onSave}
            onEditSec={this.onEditSec}
            onCancel={this.cancelEdit}
            currentFile={currentFile}
          />
        )}
        <SensitiveDialog
          visible={sensitiveVisible}
          sensitiveList={sensitiveList}
          changeSensiVisible={this.changeSensiVisible}
        />
      </div>
    );
  }
}

const Com = middleware(Main, "WeaUpload");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-upload/index.js